import { render, staticRenderFns } from "./AppDatatable.vue?vue&type=template&id=ffb7d96a&scoped=true&"
import script from "./AppDatatable.vue?vue&type=script&lang=js&"
export * from "./AppDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb7d96a",
  null
  
)

export default component.exports